import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard";
import Invoices from "./invoices";
import Plans from "./plans";
import PaymentMethods from "./payment-methods";
import PageContainer from "../../components/page-container";
import { SUBSCRIPTION_BASE } from "./components";

// Horizontal tab bar (same InternalHeader as the agent pages); each tab is its own route under
// /user-settings/subscription/*, so links such as .../plans or .../payment-methods?setup=1 open the right tab.
const navigation = [
    { name: 'Usage', href: SUBSCRIPTION_BASE, rootLink: true, end: true },
    { name: 'Plans', href: `${SUBSCRIPTION_BASE}/plans`, rootLink: true },
    { name: 'Invoices', href: `${SUBSCRIPTION_BASE}/invoices`, rootLink: true },
    { name: 'Payment methods', href: `${SUBSCRIPTION_BASE}/payment-methods`, rootLink: true },
];

export default function SubscriptionPage() {
    return (
        <PageContainer
            title="Subscription"
            subtitle="Manage your plan, usage and billing details"
            navigation={navigation}
        >
            <div className="pb-10">
                <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="plans" element={<Plans />} />
                    <Route path="invoices" element={<Invoices />} />
                    <Route path="payment-methods" element={<PaymentMethods />} />
                    <Route path="*" element={<Navigate to={SUBSCRIPTION_BASE} replace />} />
                </Routes>
            </div>
        </PageContainer>
    );
}
